module.exports = __webpack_public_path__ + "static/media/Moss.27ead9dc.png";